import React from 'react'
import Head from 'next/head'
import { Heading } from '@brewlogix/blx-ui'
import { NextPage } from 'next'
import { CompositeSearchResult } from 'src/features/search/types'
import StaticSearch from 'src/features/search/components/StaticSearch'
import { useSearch } from 'src/features/search/state/useSearch'

const Page: NextPage<{ results: CompositeSearchResult[] }> = () => {
    const { resetSearchStore } = useSearch()

    React.useEffect(() => {
        // resetSearchStore()
    }, [])

    return (
        <div className='container mx-auto pt-2'>
            <Head>
                <title>Search | BreweryDB</title>
            </Head>

            <div className='search '>
                <Heading size='h3' type='h1' text='Search' customClasses='sr-only' />

                <div className='container mx-auto min-h-screen-66 px-4 pt-0 pb-8 lg:px-8'>
                    <StaticSearch />
                </div>
            </div>
        </div>
    )
}

export default Page
